import {Link} from "react-router-dom";

const ShowVisitTimes = ({date, times}) => {
    return (
        <div className="container mt-5 p-1">
            <Link to="/reserve_visit" className="btn btn-primary font-link">بازگشت به صفحه انتخاب پزشک</Link>
            <h3>نوبت های موجود در تاریخ {date}</h3>

            {(times.length > 0) ?
                <div id="cat-panel" className="row justify-content-center mt-2">
                    {times.map((time, index) => (
                        <div key={index} className="col-md-3 g-3 font-link " id="card_parent">
                            <div className="card bg-light">
                                <div className="card-body text-center justify-content-center">
                                    <p className="pointer">ساعت شروع نوبت : {time.from_time}</p>
                                    <p className="pointer">ساعت اتمام نوبت : {time.to_time}</p>
                                    <p className="pointer">هزینه ویزیت : {time.visit_cost} ریال </p>
                                    <a className="btn btn-secondary" onClick={
                                        (e)=>{
                                            e.preventDefault();
                                            alert("هدایت به سمت درگاه پرداخت...")
                                        }
                                    }>پرداخت و گرفتن نوبت</a>
                                </div>
                            </div>
                        </div>
                    ))

                    }

                </div>

                :
                <h5>در تاریخ انتخابی تمامی نوبت های پزشک پر هستند یا پزشک در این روز ویزیت ندارند.</h5>}
        </div>
    );
}

export default ShowVisitTimes;